import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import CaseCalendarScreen, { DispatchProps, OwnProps, StateProps } from './CaseCalendarScreen';

import { StoreState } from 'src/store/reducers';
import { getCase, updateCase } from 'src/store/actions/case-actions';
import { getMultiSeances } from 'src/store/actions/seance-actions';
import { QueryParams } from 'src/types/grid';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.cases.inProgress,
        caseEnt: state.cases.current,
        seances: state.seances.data,
        inProgressSeance: state.seances.inProgress,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getCaseData: (id) => dispatch(getCase(id)),
        getData: (params: QueryParams) => dispatch(getMultiSeances(params)),
        updateCaseAction: (data) =>
            dispatch(
                updateCase(
                    data,
                    () => false,
                    (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                ),
            ),
    };
}

const CalendarScreenScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(CaseCalendarScreen);

export default CalendarScreenScreen;
